import { useQuery } from '@tanstack/react-query';
import { getFetch } from '@legacy/utils/fetcher';
import { formatUrl, isUrlPathMatched } from '@legacy/utils/url';
import { IBookmarks } from '@legacy/apis/types/bookmarksAPI';

const BOOKMARKS_URL_PATH = '/api/v2/bookmarks';
export const BOOKMARKS_MSW_STATUS_KEY = 'bookmarksAPI';

export const BOOKMARKS_KEY = 'BOOKMARKS';

const bookmarksFetch = (): Promise<IBookmarks> =>
  getFetch({ path: BOOKMARKS_URL_PATH, key: BOOKMARKS_MSW_STATUS_KEY });

export const useIsBookmarked = (currentUrl: string) => {
  const { data, ...restProps } = useQuery({
    queryKey: [BOOKMARKS_KEY],
    queryFn: bookmarksFetch,
  });

  const { properties, actions } =
    data?.entities?.find(({ properties: { url = '' } = {} }) =>
      isUrlPathMatched({ currentUrl, originUrl: url }),
    ) || {};

  const { href: deleteBookmarkUrl = '' } =
    actions?.find(({ method }) => method === 'Delete') || {};

  return {
    isBookmarked: !!properties || false,
    deleteBookmarkUrl,
    ...restProps,
  };
};

export default () => {
  const { data, ...restProps } = useQuery({
    queryKey: [BOOKMARKS_KEY],
    queryFn: bookmarksFetch,
  });
  return {
    bookmarks:
      data?.entities?.map(
        ({ properties: { url, ...restProperties } = {} }) => ({
          ...restProperties,
          url: formatUrl(url),
        }),
      ) || [],
    ...restProps,
  };
};
